import { jsx as r } from "react/jsx-runtime";
import { createContext as x, forwardRef as l, useMemo as y, useContext as S } from "react";
import * as d from "@radix-ui/react-slider";
import { Root as v, Form as w } from "../input/Input.js";
import { twMerge as n } from "tailwind-merge";
const u = x({
  min: void 0,
  max: void 0,
  value: [],
  defaultValue: void 0,
  orientation: "horizontal"
}), R = () => S(u), c = l(
  ({ className: o, orientation: e = "horizontal", ...t }, i) => {
    const a = y(
      () => ({
        min: t.min,
        max: t.max,
        value: t.value,
        defaultValue: t.defaultValue,
        orientation: e
      }),
      [t.min, t.max, t.value, t.defaultValue, e]
    );
    return /* @__PURE__ */ r(u.Provider, { value: a, children: /* @__PURE__ */ r(
      d.Root,
      {
        ref: i,
        orientation: e,
        className: n(
          "relative flex w-full touch-none select-none items-center",
          "data-[orientation=vertical]:h-full data-[orientation=vertical]:w-4 data-[orientation=vertical]:flex-col",
          "data-[orientation=horizontal]:h-4",
          o
        ),
        ...t
      }
    ) });
  }
);
c.displayName = "SliderRoot";
const N = l(
  ({ className: o, ...e }, t) => /* @__PURE__ */ r(
    d.Track,
    {
      ref: t,
      className: n(
        "relative flex-grow rounded-md bg-gray-300",
        "data-[orientation=horizontal]:h-2",
        "data-[orientation=vertical]:w-2",
        o
      ),
      ...e
    }
  )
), s = l(
  ({ className: o, ...e }, t) => /* @__PURE__ */ r(
    d.Range,
    {
      ref: t,
      className: n(
        "absolute rounded-full bg-blue-600 data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full",
        o
      ),
      ...e
    }
  )
);
s.displayName = "SliderRange";
const m = l(
  ({ className: o, ...e }, t) => /* @__PURE__ */ r(
    d.Thumb,
    {
      ref: t,
      className: n(
        "block h-5 w-5 rounded-full border-2 border-blue-500 bg-white shadow-md hover:bg-blue-100",
        "focus:shadow-sm focus-visible:ring-2 focus-visible:ring-blue-500",
        o
      ),
      ...e
    }
  )
);
m.displayName = "SliderThumb";
const f = l(
  ({ className: o, variant: e = "primary", ...t }, i) => {
    const { orientation: a } = R();
    return /* @__PURE__ */ r(
      "span",
      {
        ref: i,
        className: n(
          "absolute",
          a === "horizontal" && "left-1/2 -translate-x-1/2",
          a === "vertical" && "left-full top-1/2 -translate-y-1/2",
          a === "horizontal" && e === "primary" && "top-full",
          a === "vertical" && e === "primary" && "ml-2",
          e === "secondary" && "rounded-lg border border-gray-300 bg-white p-2 text-sm shadow-lg",
          a === "horizontal" && e === "secondary" && "bottom-full mb-2",
          a === "vertical" && e === "secondary" && "left-full ml-2",
          o
        ),
        ...t
      }
    );
  }
);
f.displayName = "SliderValueIndicator";
const h = l(
  ({ inputProps: o, className: e, value: t, defaultValue: i, ...a }, b) => {
    const g = V(t ?? i);
    return /* @__PURE__ */ r(v, { ref: b, className: n("w-36", e), ...a, children: /* @__PURE__ */ r(w, { readOnly: !0, value: g, ...o }) });
  }
);
h.displayName = "SliderInput";
const V = (o) => !o || o.length === 0 ? "0" : o.length === 1 ? o[0].toString() : o.map((e) => e.toString()).join(" - "), k = c, C = N, j = s, M = m, D = f, F = h;
export {
  F as Input,
  j as Range,
  k as Root,
  h as SliderInput,
  s as SliderRange,
  c as SliderRoot,
  m as SliderThumb,
  N as SliderTrack,
  f as SliderValueIndicator,
  M as Thumb,
  C as Track,
  D as ValueIndicator,
  V as formatDisplayValue
};
